module.exports = __webpack_public_path__ + "static/Oil Decking 1-5d93e3c046e6610365f0c164a63d9d67.jpg";